/* System defined core library */
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
import * as moment from 'moment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Observer, Subscription } from 'rxjs';

/* User defined library/components */
import { BootstrapParams } from '../../../../../bootstrap-params';
import { CultureService } from '../../../../../app/shared/services/culture.service';
import { MapUtilityService } from '../../../../map/services/map-utility.service';
import { UtilityService } from '../../../../shared/services/utility.service';
import { SchedulingApiService } from '../../services/scheduling-api.service';
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';
import { TimerService } from '../../../../shared/services/timer.service';

/* User defined models */
import { AppointmentDetail } from '../../../../shared/models/scheduling/appointmentdetail.model';
import { AppointmentSlot } from '../../../../shared/models/scheduling/appointmentSlot.model';
import { Booking } from '../../../../shared/models/scheduling/booking.model';
import { Client } from '../../../../shared/models/scheduling/client.model';
import { Country } from '../../../../shared/models/scheduling/country.model';
import { EligibilityDetail } from '../../../../shared/models/scheduling/eligibility.model';
import { Exam } from '../../../../shared/models/scheduling/exam.model';
import { Hold } from '../../../../shared/models/scheduling/hold.model';
import { LocationSelector } from '../../../../shared/models/scheduling/locationSelector.model';
import { MetricData, MetricDetails } from '../../../../shared/models/scheduling/metrics.model';
import { Program } from '../../../../shared/models/scheduling/program.model';
import { SiteSlot } from '../../../../shared/models/scheduling/siteSlot.model';
import { Slot } from '../../../../shared/models/scheduling/slot.model';
import { State } from '../../../../shared/models/scheduling/state.model';
import { TestingAccommodation } from '../../../../shared/models/scheduling/testingAccommodation.model';

/* User defined enums/constants */
import { TargetFlow, DefaultLatitude, DefaultLognitude } from '../../../../shared/constants/scheduling.constant';
import { ComponentType, DistanceUnits, MetricType } from '../../../../shared/enums/scheduling.enum';



@Component({
  selector: 'app-select-testcenter',
  templateUrl: './testcenter-selecter.component.html',
  styleUrls: ['./testcenter-selecter.component.scss']
})
export class TestCenterSelecterComponent implements OnInit {
  @HostListener('window:popstate', ['$event'])

  @HostListener('keydown', ['$event']) onKeyDown(e: any) {
    if (e.shiftKey && e.keyCode == 9) {
      this.currentTabIndex = 0; // Reset the tab index
      $('.show-more-sites').removeClass('no-outline');
    }
  }

  /* User defined private/public variables */
  public allAppointmentDetailData: AppointmentDetail[] = [];
  public applySortBy: string;
  public applicableTestingAccommodations: TestingAccommodation[];
  public booking: Booking;
  public category: string = 'siteSlot?.location?.distance';
  public client: Client;
  public country: Country;
  public currentSelectedDate: any;
  public currentTabIndex: number = 0;
  public distanceUnit: DistanceUnits;
  public defaultCalendarMonth: string;
  public deviceType: any;
  public eligibilityId: string;
  public eligibilityDetails: EligibilityDetail[] = [];
  public exam: Exam;
  public examName: string;
  public examWithTA: Exam[] = [];
  public firstTimeLocationSearch: boolean[] = [];
  public formattedAddress: string;
  public holdSlotObj: Hold;
  public holdsObjects: any;
  public indicateInvalidDateRange: boolean = false;
  public isBackToBackRequired: boolean = false;
  public IsCurrentFormChanged: Boolean;
  public isGoogleMapsValid: boolean = true;
  public IsHoldInProgress: Boolean;
  public isMoreSites: boolean = true;
  public isNextButtonEnable: boolean;
  public lat: number = DefaultLatitude;
  public lng: number = DefaultLognitude;
  public locationSelector: LocationSelector;
  public markers: any = [];
  public markerCenter: any;
  public metricsDetail: MetricDetails[];
  public noAvailability: boolean = false;
  public noSitesAvailable: boolean = false;
  public overLapEndDate: any;
  public overLapStartDate: any;
  public prevSelectedSiteSlots: SiteSlot[];
  public placeHolderText: string;
  public popup: any;
  public popLocationSelector: any;
  public preSelectedSite: SiteSlot;
  public prevSelectedSlot: Slot;
  public prevSelectedHoldObj: any = [];
  public prevSelectedHoldObjArr: any = [];
  public prevSelectionsArr: SiteSlot[] = [];
  public prevSites: any = [];
  public prevSlotSelections: any = [];
  public program: Program;
  public region: any;
  public searchRegion: State;
  public selectedAppointments: AppointmentDetail[] = []
  public selectedAvalibaleSlots: Slot[];
  public selectedEndDate: any;
  public selectedIndex: number = 0;
  public selectedLocation: string;
  public selectedSitesIds: any = [];
  public selectedSite: SiteSlot;
  public selectedSiteSlot: SiteSlot;
  public selectedStartDate: any;
  public Sites: any;
  public siteSlots: SiteSlot[];
  public skipSiteSlotsize: number;
  public slotData: any = [];
  public state: State;
  public takeSiteSlotsize: number;
  public units = DistanceUnits;
  public zoom: number;
  public zoomDefault: number = 12;
  public zoomOnFocus: number = 15;
  public schedulingError: string = '';
  public startDateError: string = '';
  public endDateError: string = '';
  public toggleCalendar: boolean = false;
  public formattedDate: string;
  public testCenterCalendarDays: number;
  public selectedSiteSlotIdentifier: string;
  public testCenterDateLabel = new Map();
  public testCenterMonth = new Map();
  public testCenterDate = new Map();

  public today = new Date();
  public datePipe = new DatePipe("en-US");
  public regex = new RegExp(/\-/g);

  public startDateOptions: kendo.ui.DatePickerOptions;
  public endDateOptions: kendo.ui.DatePickerOptions;

  /* Input-OutPut parameters decalartions */
  @Input() scheduledSlot: AppointmentSlot;
  @Input() targetFlow: string = "";
  @Output() selectedSiteDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() setPlaceHolder = new EventEmitter<any>();
  @Output() slotsCheck: EventEmitter<boolean> = new EventEmitter<boolean>();

  /* Service subscriptions */
  appointmentDetailData$: Subscription;
  booking$: Subscription;
  client$: Subscription;
  country$: Subscription;
  defaultCalendarMonth$: Subscription;
  distanceUnit$: Subscription;
  exam$: Subscription;
  eligibility$: Subscription;
  eligibilityDetails$: Subscription;
  firstTimeLocationSearch$: Subscription;
  hold$: Subscription;
  locationSelector$: Subscription;
  metricsDetail$: Subscription;
  overLapEndDate$: Subscription;
  overLapStartDate$: Subscription;
  prevSelectedHoldObj$: Subscription;
  prevSelectedSite$: Subscription;
  prevSelectedSiteSlots$: Subscription;
  prevSelectedSlot$: Subscription;
  prevSelectionsArr$: Subscription; // selected sites
  prevSites$: Subscription; // previous searched sites
  prevSlotSelections$: Subscription; // selected slots
  program$: Subscription;
  region$: Subscription;
  selectedAppointments$: Subscription;
  selectedAvalibaleSlots$: Subscription;
  selectedEndDate$: Subscription;
  selectedStartDate$: Subscription;
  skipSize$: Subscription;
  state$: Subscription;
  testingAccommodation$: Subscription;
  translateLanguage$: Subscription;

  @ViewChild('testcenterLocation') testcenterLocation: ElementRef;

  /* Constructor declaration with required injected services */
  constructor(
    private cultureService: CultureService,
    private deviceService: DeviceDetectorService,
    private mapUtilityService: MapUtilityService,
    private schedulingApiService: SchedulingApiService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService,
    private utilityService: UtilityService,
    private timerService: TimerService,
    private bootstrapParams: BootstrapParams
  ) {
    this.appointmentDetailData$ = selectedExamDetailService.appointmentDetailData.subscribe(
      appointmentDetailData => {
        this.allAppointmentDetailData = appointmentDetailData;
      });

    this.booking$ = selectedExamDetailService.booking.subscribe(
      booking => {
        this.booking = booking;
      });

    this.client$ = selectedExamDetailService.client.subscribe(
      client => {
        this.client = client;
      });

    this.country$ = selectedExamDetailService.lpiCountry.subscribe(
      country => {
        this.country = country;
      });

    this.defaultCalendarMonth$ = selectedExamDetailService.defaultCalendarMonth.subscribe(
      defaultCalendarMonth => {
        this.defaultCalendarMonth = defaultCalendarMonth;
      });

    this.distanceUnit$ = selectedExamDetailService.distanceUnit.subscribe(
      unit => {
        this.distanceUnit = unit;
      });

    this.eligibilityDetails$ = selectedExamDetailService.eligibilityDetails.subscribe(
      value => {
        this.eligibilityDetails = value || [];
      });

    this.exam$ = selectedExamDetailService.exam.subscribe(
      exam => {
        this.exam = exam;
      });

    this.firstTimeLocationSearch$ = selectedExamDetailService.firstTimeLocationSearch.subscribe(
      value => {
        let boolVal: boolean[] = [];
        boolVal.push(false);
        this.firstTimeLocationSearch = value == null ? boolVal : value;
      });

    this.hold$ = selectedExamDetailService.hold.subscribe(
      hold => {
        this.holdSlotObj = hold;
      });

    this.locationSelector$ = selectedExamDetailService.locationSelector.subscribe(
      locationSelector => {
        this.locationSelector = locationSelector;
      });

    this.metricsDetail$ = selectedExamDetailService.metricsDetail.subscribe(
      metricsDetail => {
        this.metricsDetail = metricsDetail;
      });

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });

    this.overLapEndDate$ = selectedExamDetailService.overlapsToDate.subscribe(
      endDate => {
        this.overLapEndDate = endDate;
      });

    this.overLapStartDate$ = selectedExamDetailService.overlapsFromDate.subscribe(
      startDate => {
        this.overLapStartDate = startDate;
      });

    this.prevSelectedHoldObj$ = selectedExamDetailService.prevSelectedHoldObj.subscribe(
      prevSelectedHoldObj => {
        this.prevSelectedHoldObj = prevSelectedHoldObj;
        if (this.prevSelectedHoldObj) {
          this.prevSelectedHoldObjArr = prevSelectedHoldObj;
        }
      });

    this.prevSelectedSite$ = this.selectedExamDetailService.siteSlot.subscribe(
      siteSlot => {
        this.preSelectedSite = siteSlot;
        this.selectedSite = siteSlot;
      });

    this.prevSelectedSiteSlots$ = this.selectedExamDetailService.prevSiteSlots.subscribe(
      siteSlots => {
        this.prevSelectedSiteSlots = siteSlots;
      });

    this.prevSelectedSlot$ = this.selectedExamDetailService.slot.subscribe(
      slot => {
        this.prevSelectedSlot = slot;
      });

    // selected sites until now
    this.prevSelectionsArr$ = this.selectedExamDetailService.prevSelections.subscribe(
      siteSlots => {
        this.prevSelectionsArr = siteSlots || [];
      });

    this.prevSites$ = this.selectedExamDetailService.prevSites.subscribe(
      sites => {
        this.prevSites = sites || [];
      })

    // selected slots until now
    this.prevSlotSelections$ = this.selectedExamDetailService.prevSlotSelections.subscribe(
      slots => {
        this.prevSlotSelections = slots || [];
      });

    this.program$ = selectedExamDetailService.program.subscribe(
      program => {
        this.program = program;
      });

    this.region$ = selectedExamDetailService.region.subscribe(
      region => {
        this.region = region;
      });

    this.skipSize$ = selectedExamDetailService.skipSize.subscribe(
      skipSize => {
        this.skipSiteSlotsize = skipSize || 0;
      });

    this.selectedAppointments$ = selectedExamDetailService.selectedAppointmentDetails.subscribe(
      selectedAppointments => {
        this.selectedAppointments = selectedAppointments;
      });

    this.selectedAvalibaleSlots$ = this.selectedExamDetailService.selectedAvalibaleSlots.subscribe(
      availableSlots => {
        this.selectedAvalibaleSlots = availableSlots;
      });

    this.selectedEndDate$ = selectedExamDetailService.selectedEndDate.subscribe(
      selectedEndDate => {
        this.selectedEndDate = selectedEndDate;
      });

    this.selectedStartDate$ = selectedExamDetailService.selectedStartDate.subscribe(
      selectedStartDate => {
        this.selectedStartDate = selectedStartDate;
      });

    this.state$ = selectedExamDetailService.lpiState.subscribe(
      state => {
        this.state = state;
      });

    this.testingAccommodation$ = selectedExamDetailService.applicableTestingAccommodations.subscribe(
      testingAccommodation => {
        this.applicableTestingAccommodations = testingAccommodation;
      });

    this.startDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      min: this.getValidStart(),
      max: this.getValidStartDateEnd(),
      start: "month",
      disableDates: [this.today]
    };

    this.endDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      start: "month"
    };

    this.deviceType = this.deviceService.getDeviceInfo().browser;
    this.isBackToBackRequired = this.selectedExamDetailService.isBackToBackRequired;
    this.isGoogleMapsValid = this.selectedExamDetailService.isGoogleMapsValid;
    this.selectedIndex = this.selectedExamDetailService.selectedAppointmentIndex;
    this.zoom = this.zoomDefault;

    this.searchRegion = this.region;
    this.formattedAddress = !!this.region ? this.region.name : 'locationSelectorComponent.placeholderText';
    this.setPlaceHolder.emit(this.formattedAddress);

    this.popLocationSelector = {
      title: "",
      content: "<em class='fa fa-calendar' aria-hidden='true' style='color:green;'></em>",
      placement: "bottom",
      actionTxt: ((this.selectedAppointments) && this.selectedAppointments[this.selectedIndex].region) ? this.selectedAppointments[this.selectedIndex].region.name : "",
      appliedClass: "btn secNavAction",
      showHeaderFooter: false,
      refBlock: "LocationSelector",
      locationSelector: true,
      focusChildElement: 'locationSelector'
    };

    if (this.Sites) {
      this.Sites.map((site: any) => {
        this.selectedSitesIds.push(site.id);
      });
    }
    this.testCenterCalendarDays = this.bootstrapParams.testCenterCalendarDays;
    this.takeSiteSlotsize = this.bootstrapParams.testCenterTakeSize;
    this.placeHolderText = this.selectedExamDetailService.dateFormat.toUpperCase()
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.TestCenterSelecterComponent)) return;

    this.noAvailability = false;

    if (this.selectedAppointments.length > 0 && !this.isBackToBackRequired) {
      //this.client = (this.booking != null && this.booking != undefined) ? this.booking.client : this.selectedAppointments[this.selectedIndex].client;
      this.program = this.selectedAppointments[this.selectedIndex].program;
      this.exam = this.selectedAppointments[this.selectedIndex].exam;
      this.region = this.selectedAppointments[this.selectedIndex].region;
      this.examName = this.selectedAppointments[this.selectedIndex].exam.name;
      this.selectedStartDate = this.selectedAppointments[this.selectedIndex].selectedStartDate;
      this.selectedEndDate = this.selectedAppointments[this.selectedIndex].selectedEndDate;

      // Push exam set TA with Exam in case of Search Availibility.
      // Will be verify for in case of B2B grouped
      let tempExamWithTA: any = { id: this.exam.id, testingAccommodations: this.exam.testingAccommodations }
      this.examWithTA.push(tempExamWithTA);

    }
    else if (this.selectedAppointments.length > 0 && this.isBackToBackRequired) {

      this.selectedAppointments.forEach((appointment) => {

        // Set Exam With TA to pass in Site Availability call with new Implementation
        let tempExamWithTA: any = { id: appointment.exam.id, testingAccommodations: appointment.exam.testingAccommodations }
        this.examWithTA.push(tempExamWithTA);
      });

      this.examName = this.selectedAppointments[0].exam.name;
      this.selectedStartDate = this.selectedAppointments[this.selectedIndex].selectedStartDate;
      this.selectedEndDate = this.selectedAppointments[this.selectedIndex].selectedEndDate;
    }

    var selectedStartDate = this.utilityService.getFormatToMMDDYYYY(new Date(this.selectedStartDate['jsdate']), "-");
    var selectedEndDate = this.utilityService.getFormatToMMDDYYYY(new Date(this.selectedEndDate['jsdate']), "-");
    this.applySortBy = "Distance"; //Default Sorting
    // when user go back then check if prev Site slots value
    if (this.prevSelectedSiteSlots == null || this.prevSelectedSiteSlots == undefined) {
      const searchLocation = this.region ? this.region.lat : this.country.id;
      const searchLocation2 = this.region ? this.region.long : this.state ? this.state.id : null;
      this.getSites(
        selectedStartDate,
        selectedEndDate,
        searchLocation,
        searchLocation2
      ).subscribe((siteSlots: any) => {
        this.selectedSiteSlotIdentifier = this.selectedSite ? this.getSelectedSiteSlotIdentifier() : "";
        siteSlots.forEach((slots: any) => {
          slots.availability = slots.availability.slice(0, this.testCenterCalendarDays);
          slots.availability.forEach((availDate: string) => {
            var slotIdentifier = this.generateSiteSlotIdentifier(slots, availDate);
            this.testCenterDateLabel.set(slotIdentifier, this.utilityService.convertDateToWords(availDate, ','));
            this.testCenterMonth.set(slotIdentifier, this.datePipe.transform(availDate, 'MMM').toUpperCase());
            this.testCenterDate.set(slotIdentifier, this.datePipe.transform(availDate, 'dd'));
          });
        });
        this.siteSlots = siteSlots;
        this.selectedExamDetailService.setSiteSlots(this.siteSlots); // Set Site slots for use when user come back same page
        if (this.lat && this.region) this.loadMapWithMarkers(this.siteSlots);


        if (!this.isBackToBackRequired) {
          // todo need a better approach.
          //should be same  for multiple or single or any case - MM
          if (!(this.prevSites &&
            this.prevSites.length
            && this.prevSites[this.selectedIndex]
            && this.prevSites[this.selectedIndex].length

          )) {
            this.prevSites = this.checkIfExists(this.prevSites, this.siteSlots);
            this.selectedExamDetailService.setPrevSites(this.prevSites);
          } else {
            this.selectedSiteSlotIdentifier = this.selectedSite ? this.getSelectedSiteSlotIdentifier() : "";
            this.prevSites[this.selectedIndex].forEach((slots: any) => {
              slots.availability = slots.availability.slice(0, this.testCenterCalendarDays);
              slots.availability.forEach((availDate: string) => {
                var slotIdentifier = this.generateSiteSlotIdentifier(slots, availDate);
                this.testCenterDateLabel.set(slotIdentifier, this.utilityService.convertDateToWords(availDate, ','));
                this.testCenterMonth.set(slotIdentifier, this.datePipe.transform(availDate, 'MMM').toUpperCase());
                this.testCenterDate.set(slotIdentifier, this.datePipe.transform(availDate, 'dd'));
              });
            });
            this.siteSlots = this.prevSites[this.selectedIndex];
            this.selectedExamDetailService.setSiteSlots(this.siteSlots);
            if (this.lat && this.region) this.loadMapWithMarkers(this.siteSlots);
            if (this.selectedAppointments.length > 1 && this.prevSlotSelections.length && !this.isBackToBackRequired) {
              this.selectedSiteSlot = this.prevSelectionsArr[this.selectedIndex];
              this.selectedSiteSlot.slots = this.prevSlotSelections[this.selectedIndex];
            }
          }
        }

      });
    }
    else if (this.selectedAppointments.length < 2 || this.isBackToBackRequired) {
      this.selectedSiteSlotIdentifier = this.selectedSite ? this.getSelectedSiteSlotIdentifier() : "";
      this.prevSelectedSiteSlots.forEach((slots: any) => {
        slots.availability = slots.availability.slice(0, this.testCenterCalendarDays);
        slots.availability.forEach((availDate: string) => {
          var slotIdentifier = this.generateSiteSlotIdentifier(slots, availDate);
          this.testCenterDateLabel.set(slotIdentifier, this.utilityService.convertDateToWords(availDate, ','));
          this.testCenterMonth.set(slotIdentifier, this.datePipe.transform(availDate, 'MMM').toUpperCase());
          this.testCenterDate.set(slotIdentifier, this.datePipe.transform(availDate, 'dd'));
        });
      });
      // Set Already Site slots
      this.siteSlots = this.prevSelectedSiteSlots;
      if (this.lat) this.loadMapWithMarkers(this.siteSlots);
    }


    // Show Previously selected site and their selected slot if user back to previous from candidate page.
    if (this.preSelectedSite != null && this.preSelectedSite != undefined) {
      this.selectedSiteSlot = this.preSelectedSite;
    }

    if (this.selectedAvalibaleSlots != null && this.selectedAvalibaleSlots != undefined && this.selectedSiteSlot != null) {
      this.selectedSiteSlot.slots = this.selectedAvalibaleSlots;
    }

    this.selectedExamDetailService.prevSelectedPopoverObject = null;

    this.IsCurrentFormChanged = false;
    this.popup = {
      title: "",
      content: "long page string .....................",
      placement: "bottom",
      actionTxt: "testCenterSelecterComponent.moreDatesAtThisTestCenter",
      appliedClass: "btn moreAction",
      showHeaderFooter: false,
      refBlock: "MoreDate",
      locationSelector: false,
      isSlotSelected: false,
      focusChildElement: 'calendarWrpr'
    };

    this.isNextButtonEnable = true;
    this.IsHoldInProgress = false;
    if (this.targetFlow == "" || this.targetFlow == undefined) {
      this.targetFlow = this.selectedExamDetailService.currentTargetFlow;
    }

    // set default focus on parant div for screen reader
    if (this.testcenterLocation != undefined)
      this.testcenterLocation.nativeElement.focus();

    this.setSelectedStartDate(this.selectedStartDate);
    this.setSelectedEndDate(this.selectedEndDate);

    this.startDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      min: this.getValidStart(),
      max: this.getValidStartDateEnd(),
      start: "month",
      disableDates: [this.today]
    };

    if (this.selectedStartDate) {
      this.endDateOptions = {
        format: this.selectedExamDetailService.dateFormat,
        culture: this.selectedExamDetailService.browserCulture,
        min: this.getValidEndDateStart(),
        max: this.getValidEndDateEnd(),
        start: "month",
        disableDates: [this.today]
      };
    }
  }

  getSelectedSiteSlotIdentifier() {
    return this.selectedSite.id + "_" + this.selectedSite.Testdate.replace(/\-/g, "");
  }

  generateSiteSlotIdentifier(slot: SiteSlot, date: string) {
    return slot.id + "_" + date.split('T')[0].replace(/\-/g, "");
  }

  /* API call to get Sites */
  getSites(
    startDate?: any,
    endDate?: any,
    latitude?: any,
    lognitude?: any
  ): any {
    this.selectedSiteSlot = null;
    this.isMoreSites = true;
    let eligibilityId = this.eligibilityDetails ? this.eligibilityDetails[0] && this.eligibilityDetails[0].id : '-1';

    return new Observable((observer: Observer<any>) => {
      this.schedulingApiService.getSites(
        startDate,
        endDate,
        latitude,
        lognitude,
        this.takeSiteSlotsize,
        this.skipSiteSlotsize,
        this.isBackToBackRequired,
        this.examWithTA,
        eligibilityId,
        this.isGoogleMapsValid
      ).subscribe(response => {
        let siteSlots = response.siteSlots;
        this.schedulingError = response.error;
        if (siteSlots.length == 0 && !this.firstTimeLocationSearch[this.selectedIndex]) {
          this.setMetricsDetail(
            MetricType.Searched,
            null,
            null
          );
        }

        siteSlots = siteSlots.map((s: any) => {
          s.availability = s.availability.map((a: any) => a ? a.split("T")[0] : a);
          return s;
        });

        if (siteSlots.length > 0) {
          this.setMetricsDetail(
            MetricType.BestSite,
            siteSlots[0].id,
            siteSlots[0].Testdate
          );
        }
        siteSlots.sort(this.ApplySorting(this.applySortBy, this.deviceType));

        this.selectedExamDetailService.setSiteSlots(siteSlots);
        observer.next(siteSlots);
        observer.complete();
      });
    });
  }

  /* API call to get slots */
  getSlots(
    siteId?: string,
    StartDateTime?: any,
    endDateTime?: any
  ): any {
    let eligibilityId = this.eligibilityDetails ? this.eligibilityDetails[0] && this.eligibilityDetails[0].id : '-1';
    return new Observable((observer: Observer<any>) => {
      this.schedulingApiService.getSlots(
        siteId,
        StartDateTime,
        endDateTime,
        this.examWithTA,
        eligibilityId,
        this.selectedExamDetailService.timeFormat
      ).subscribe(resp => {
        if (!!resp && !!resp.itinerary && resp.itinerary.length > 0) {
          resp.itinerary.forEach((test: any, index: number) => {
            this.selectedAppointments[index].exam.duration = test.duration;
          });
        }
        observer.next(resp.slots);
        observer.complete();
      });
    });
  }

  /* Load markers based on available sites */
  loadMapWithMarkers(siteSlots: SiteSlot[]): void {
    this.markers = this.mapUtilityService.getMapMarkersFromSlots(siteSlots);
  }

  resetCurrentSelection(): void {
    this.selectedAppointments.forEach((appt: AppointmentDetail) => {
      appt.appointmentSlot = new AppointmentSlot();
      appt.hold = new Hold();
    });
  }

  sort(event: any): void {
    event.preventDefault();
    this.applySortBy = event.target.value;
    this.siteSlots.sort(this.ApplySorting(this.applySortBy, this.deviceType));
    this.prevSites = this.checkIfExists(this.prevSites, this.siteSlots);
    this.selectedExamDetailService.setPrevSites(this.prevSites);
    this.IsCurrentFormChanged = true;
  }

  /* Get the location selected by user and emit to parent */
  getGeoLocation(event: any, value: any): void {
    this.searchRegion = { id: '', lat: this.selectedLocation[0], long: this.selectedLocation[1], uri: '', name: this.selectedLocation[2] };
    this.formattedAddress = this.searchRegion.name;
    this.IsCurrentFormChanged = true;
  }

  /* Refresh siteslot page if user has changed date range */
  refreshSiteSlotsBydate(selectedStartDate: any, siteSlot?: SiteSlot): void {
    let siteIndex: number = this.siteSlots.indexOf(siteSlot);
    if (siteIndex > -1) {
      let tempSiteSlot: any = siteSlot;
      let avldate: any = moment(new Date(selectedStartDate['jsdate'])).format("YYYY-MM-DD");
      tempSiteSlot.availability = [avldate]
      tempSiteSlot.Testdate = moment(this.utilityService.getFormatToMMDDYYYY(new Date(selectedStartDate['jsdate']), "-")).format('YYYY-MM-DD');
      var formatStartDate = this.utilityService.getFormatToMMDDYYYY(new Date(selectedStartDate['jsdate']), "-");
      this.getSlots(tempSiteSlot.id, formatStartDate, formatStartDate).subscribe((slotDetails: any) => {
        tempSiteSlot.slots = slotDetails;
        this.selectedSiteSlot = tempSiteSlot;
        this.selectedSiteSlot.slots = this.setApplicableSlots(siteSlot).slots;

        this.noAvailability = !this.selectedSiteSlot.slots.length;
        // update available slots
        this.selectedExamDetailService.setSelectedAvailableSlots(this.selectedSiteSlot.slots);

        this.selectedSiteSlotIdentifier = this.selectedSite ? this.getSelectedSiteSlotIdentifier() : "";
        tempSiteSlot.availability = tempSiteSlot.availability.slice(0, this.testCenterCalendarDays);
        tempSiteSlot.availability.forEach((availDate: string) => {
          var slotIdentifier = this.generateSiteSlotIdentifier(tempSiteSlot, availDate);
          this.testCenterDateLabel.set(slotIdentifier, this.utilityService.convertDateToWords(availDate, ','));
          this.testCenterMonth.set(slotIdentifier, this.datePipe.transform(availDate, 'MMM').toUpperCase());
          this.testCenterDate.set(slotIdentifier, this.datePipe.transform(availDate, 'dd'));
        });

        this.siteSlots[siteIndex] = tempSiteSlot;
        this.prevSites = this.checkIfExists(this.prevSites, this.siteSlots);
        this.selectedExamDetailService.setPrevSites(this.prevSites);
      });
    }
  }

  /* Set Selected StartDate in shared service*/
  setSelectedStartDate(value: any): void {
    const today = new Date();
    var year = value && value['date'] ? value['date']['year'] : new Date().getFullYear();
    var month = value && value['date'] ? value['date']['month'] : new Date().getMonth();
    var day = value && value['date'] ? value['date']['day'] : new Date().getDate();

    var currentDate = new Date(year, month - 1, day);
    currentDate.setHours(0, 0, 0, 0)
    today.setHours(0, 0, 0, 0);
    if (currentDate && currentDate < today) this.startDateError = "Start date must be a date in the future.";
    else if (currentDate && currentDate >= today) {
      this.startDateError = '';
      this.toggleCalendar = true;
      this.selectedStartDate = value;
      this.selectedExamDetailService.setSelectedStartDate(this.selectedStartDate);
      if (!this.selectedEndDate) {
        this.endDateError = '';
        this.selectedEndDate = value;
        this.selectedExamDetailService.setSelectedEndDate(this.selectedEndDate);
      }
      if (this.selectedEndDate) {
        const start = new Date(value['date']['year'], value['date']['month'] - 1, value['date']['day']);
        const end = new Date(this.selectedEndDate['date']['year'],
          this.selectedEndDate['date']['month'] - 1,
          this.selectedEndDate['date']['day']);
        const endLimit = new Date(start);
        endLimit.setDate(start.getDate() + 14);

        endLimit.setHours(0, 0, 0, 0);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        if (end > endLimit || end < start) {
          this.endDateError = '';
          this.selectedEndDate = value;
          this.selectedExamDetailService.setSelectedEndDate(this.selectedEndDate);
        } else {
          this.endDateError = '';
        }
      }
    }

    this.endDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      min: this.getValidEndDateStart(),
      max: this.getValidEndDateEnd(),
      start: "month",
      disableDates: [this.today]
    };
  }

  /* Set selected end date in shared service */
  setSelectedEndDate(value: any): void {
    var year = value && value['date'] ? value['date']['year'] : new Date().getFullYear();
    var month = value && value['date'] ? value['date']['month'] : new Date().getMonth();
    var day = value && value['date'] ? value['date']['day'] : new Date().getDate();
    var currentDate = new Date(year, month - 1, day);

    const selectedStartDate =
      new Date(this.selectedStartDate['date']['year'], this.selectedStartDate['date']['month'] - 1, this.selectedStartDate['date']['day'])

    const endLimit = new Date(selectedStartDate);
    endLimit.setDate(selectedStartDate.getDate() + 15);

    endLimit.setHours(0, 0, 0, 0)
    currentDate.setHours(0, 0, 0, 0);
    selectedStartDate.setHours(0, 0, 0, 0);
    if (!currentDate)
      this.endDateError = 'You must select an end date that is within 2 weeks of the selected start date.';

    if (currentDate && (currentDate > endLimit || currentDate < selectedStartDate))
      this.endDateError = "You must select an end date that is within 2 weeks of the selected start date.";

    else if (currentDate && currentDate < endLimit && currentDate >= selectedStartDate) {
      this.endDateError = '';
      this.toggleCalendar = false;
      this.selectedEndDate = value;
      this.selectedExamDetailService.setSelectedEndDate(this.selectedEndDate);
    }
  }

  getValidStart(): Date {
    return this.utilityService.getValidStart(this.overLapStartDate);
  }

  getValidStartDateEnd(): Date {
    return this.utilityService.getValidStartDateEnd(this.overLapStartDate, this.overLapEndDate);
  }

  getValidEndDateEnd(): Date {
    return this.utilityService.getValidEndDateEnd(this.selectedStartDate['date'], this.overLapEndDate, this.bootstrapParams.defaultSearchDateRange);
  }

  getValidEndDateStart(): Date {
    const beginDate = this.selectedStartDate['date'];
    return this.utilityService.getValidEndDateStart(beginDate);
  }

  getTodayDate() {
    return this.utilityService.getTodayDate("testcenter");
  }

  submitSearch() {
    this.selectedExamDetailService.setRegion(this.searchRegion);
    this.slotsCheck.emit(false);
    
    if (this.region) {
      this.lat = this.region.lat;
      this.lng = this.region.long;
    }

    //sets location for /scheduling/scheduleTestcenter
    this.selectedAppointments[this.selectedIndex].region = this.region;
    //sets location for /scheduling/scheduleLocation
    this.locationSelector.region = this.region;

    const searchLocation = this.region ? this.region.lat : this.country.id;
    const searchLocation2 = this.region ? this.region.long : this.state ? this.state.id : null;
    var formatStartDate = this.utilityService.getFormatToMMDDYYYY(new Date(this.selectedStartDate['jsdate']), "-");
    var formatEndDate = this.utilityService.getFormatToMMDDYYYY(new Date(this.selectedEndDate['jsdate']), "-");
    this.skipSiteSlotsize = 0;
    this.selectedExamDetailService.setSkipSize(this.skipSiteSlotsize);
    this.zoom = this.zoomDefault;

    this.getSites(
      formatStartDate,
      formatEndDate,
      searchLocation,
      searchLocation2
    ).subscribe((siteSlots: any) => {
      this.selectedSiteSlotIdentifier = "";
      siteSlots.forEach((slots: any) => {
        slots.availability = slots.availability.slice(0, this.testCenterCalendarDays);
        slots.availability.forEach((availDate: string) => {
          var slotIdentifier = this.generateSiteSlotIdentifier(slots, availDate);
          this.testCenterDateLabel.set(slotIdentifier, this.utilityService.convertDateToWords(availDate, ','));
          this.testCenterMonth.set(slotIdentifier, this.datePipe.transform(availDate, 'MMM').toUpperCase());
          this.testCenterDate.set(slotIdentifier, this.datePipe.transform(availDate, 'dd'));
        });
      });
      this.siteSlots = siteSlots;
      if (this.lat && this.region) this.loadMapWithMarkers(this.siteSlots);

      this.prevSites = this.checkIfExists(this.prevSites, this.siteSlots);
      this.selectedExamDetailService.setPrevSites(this.prevSites);
      this.resetCurrentSelection();
    });
  }

  canSearch() {
    return !!this.selectedStartDate
      && !!this.selectedEndDate
      && !this.startDateError
      && !this.endDateError
      && (!this.isGoogleMapsValid || !!this.searchRegion)
      && (!!this.region || !!this.country);
  }

  getSiteData(selectedStartDate: any, siteSlot: any): void {
    var formatStartDate = this.utilityService.getFormatToMMDDYYYY(new Date(selectedStartDate['jsdate']), "-");

    this.slotData = null;
    this.selectedSiteSlot = null; // Existing slot also get removed
    this.getSlots(siteSlot.id, formatStartDate, formatStartDate).subscribe((slotDetails: any) => {
      siteSlot.slots = slotDetails;
      siteSlot.slots = this.setApplicableSlots(siteSlot).slots;
      this.noAvailability = !siteSlot.slots.length;
      this.slotData = siteSlot;
      // update available slots while show slots popup over click on calendar date:
      this.selectedExamDetailService.setSelectedAvailableSlots(siteSlot.slots);
    });
  }

  /* Set selected slot so that user can hold it */
  setSelectedSlot(siteSltObj: SiteSlot, selSlot: Slot): void {

    if (this.holdSlotObj && this.holdSlotObj.id) {
      // release hold when a slot is selected again
      this.schedulingApiService.releaseHold(this.holdSlotObj).subscribe((res) => {
        this.prevSelectedHoldObjArr = this.prevSelectedHoldObjArr.filter((slotObj: Hold) => {
          return this.holdSlotObj.slot.id != slotObj.slot.id
        });
        this.timerService.clearClock();
        this.selectedExamDetailService.setprevSelectedHoldObj(this.prevSelectedHoldObjArr);
      });
    }

    if (this.isBackToBackRequired && this.selectedAppointments.length > 1) {
      this.selectedAppointments.forEach((appt) => {
        if (appt.hold && appt.hold.id) {
          this.schedulingApiService.releaseHold(appt.hold).subscribe((res) => {
            this.prevSelectedHoldObjArr = this.prevSelectedHoldObjArr.filter((slotObj: Hold) => {
              return this.holdSlotObj.slot.id != slotObj.slot.id
            });
            this.selectedExamDetailService.setprevSelectedHoldObj(this.prevSelectedHoldObjArr);
          })
        }
      })
    }

    this.selectedSite = siteSltObj;
    this.holdSlotObj = new Hold();
    this.holdSlotObj.slot = selSlot;
    this.selectedExamDetailService.setSiteSlot(this.selectedSite);
    this.selectedExamDetailService.setSlot(selSlot);

    this.selectedAppointments.forEach((appt: AppointmentDetail, index: number) => {
      this.selectedAppointments[index].status = 'schedule';
      this.selectedAppointments[index].appointmentSlot.site = siteSltObj;
      this.selectedAppointments[index].hold = new Hold();
      this.selectedAppointments[index].hold.slot = selSlot;
      this.selectedAppointments[index].appointmentSlot.duration = this.selectedAppointments[index].exam.duration;

      if (index === 0) {
        this.selectedAppointments[index].appointmentSlot.testTime = selSlot.testTime;
        this.selectedAppointments[index].appointmentSlot.startDateTime = new Date(this.utilityService.getFormatToFullMMDDYYYY(selSlot.startDateTime, "/"));
      } else {
        this.selectedAppointments[index].appointmentSlot.testTime = this.selectedAppointments[index - 1].appointmentSlot.testEndTime;
        this.selectedAppointments[index].appointmentSlot.startDateTime = UtilityService.addMins(
          this.selectedAppointments[index - 1].appointmentSlot.startDateTime,
          this.selectedAppointments[index - 1].appointmentSlot.duration
        );
      }

      this.selectedAppointments[index].appointmentSlot.testEndTime = this.utilityService.getStartEndFormat(
        UtilityService.addMins(
          this.selectedAppointments[index].appointmentSlot.startDateTime,
          this.selectedAppointments[index].appointmentSlot.duration
        )
      );
    });

    this.selectedExamDetailService.setSelectedAppointmentDetails(this.selectedAppointments);
    if (!this.selectedExamDetailService.isBackToBackRequired) {
      if (this.prevSelectionsArr && this.prevSelectionsArr.length) {
        if (this.prevSelectionsArr.length >= (this.selectedIndex + 1)) {
          this.prevSelectionsArr[this.selectedIndex] = siteSltObj;
          this.prevSlotSelections[this.selectedIndex] = siteSltObj.slots;
        } else {
          this.prevSelectionsArr.push(siteSltObj);
          this.prevSlotSelections.push(siteSltObj.slots);
        }
      } else {
        this.prevSelectionsArr.push(siteSltObj);
        this.prevSlotSelections.push(siteSltObj.slots);
      }
      this.selectedExamDetailService.setPrevSelections(this.prevSelectionsArr);
      this.selectedExamDetailService.setPrevSlotSelections(this.prevSlotSelections);
    }

    this.IsCurrentFormChanged = true;
    this.currentTabIndex = 0;

    this.selectedSiteDetails.emit({
      selectedAppointments: this.selectedAppointments,
      holdSlotObj: this.holdSlotObj,
      selectedIndex: this.selectedIndex,
      metricsDetail: this.metricsDetail
    });

    this.slotsCheck.emit(true);
    if (this.selectedSite == null || this.selectedSite == undefined) {
      this.selectedSiteDetails.emit({});
    }
  }

  /* Refresh site slot screen if user changes anything in popup */
  setChangeFlag(event: any) {
    this.IsCurrentFormChanged = true;
    this.setSelectedSlot(event.selectedSite, event.selectedSlot);
  }

  /* Show more sites based on default size */
  showMoreSites() {
    $(".show-more-sites").addClass('no-outline');
    this.skipSiteSlotsize += this.takeSiteSlotsize;
    this.selectedExamDetailService.setSkipSize(this.skipSiteSlotsize);
    var formatStartDate = this.utilityService.getFormatToMMDDYYYY(new Date(this.selectedStartDate['jsdate']), "-");
    var formatEndDate = this.utilityService.getFormatToMMDDYYYY(new Date(this.selectedEndDate['jsdate']), "-");
    const searchLocation = this.region ? this.region.lat : this.country.id;
    const searchLocation2 = this.region ? this.region.long : this.state ? this.state.id : null;
    this.getSites(
      formatStartDate,
      formatEndDate,
      searchLocation,
      searchLocation2
    ).subscribe((siteSlots: any) => {
      var updatedSiteList = this.siteSlots.concat(siteSlots);
      updatedSiteList.forEach((slots: any) => {
        slots.availability = slots.availability.slice(0, this.testCenterCalendarDays);
        slots.availability.forEach((availDate: string) => {
          var slotIdentifier = this.generateSiteSlotIdentifier(slots, availDate);
          this.testCenterDateLabel.set(slotIdentifier, this.utilityService.convertDateToWords(availDate, ','));
          this.testCenterMonth.set(slotIdentifier, this.datePipe.transform(availDate, 'MMM').toUpperCase());
          this.testCenterDate.set(slotIdentifier, this.datePipe.transform(availDate, 'dd'));
        });
      });
      this.siteSlots = updatedSiteList;
      // Show More Button should be disabled if we run out of sites.
      this.isMoreSites = siteSlots.length === this.takeSiteSlotsize;
      this.selectedExamDetailService.setSiteSlots(this.siteSlots);
      if (this.lat && this.region) this.loadMapWithMarkers(this.siteSlots);
      this.prevSites = this.checkIfExists(this.prevSites, this.siteSlots);
      this.selectedExamDetailService.setPrevSites(this.prevSites);
      if (this.selectedSite) {
        this.selectedSiteSlot = this.selectedSite;
      }
      this.addSitesAlert();
    });
  }

  //Adding a a one time per click alert to be read by a screenreader when more sites are retrieved
  addSitesAlert() {
    if (this.isMoreSites) {
      const sitesAlert: HTMLElement = document.getElementById('moreSitesAlert');
      var div = document.createElement('div');
      var alertText = document.createTextNode("More Sites have been added to the list");
      div.appendChild(alertText);
      div.setAttribute('role', 'alert');
      sitesAlert.append(div);

      setTimeout(() => {
        sitesAlert.removeChild(div);
      }, 5000);
    }
  }

  /* Show the available slots if user click on any site date card. */
  showSlotDetails(event: any, selectedStartDate: any, siteSlot: SiteSlot): void {

    selectedStartDate = moment(selectedStartDate).format('YYYY-MM-DD');

    siteSlot.Testdate = selectedStartDate;
    this.selectedSiteSlot = siteSlot;
    this.selectedSiteSlotIdentifier = this.generateSiteSlotIdentifier(siteSlot, selectedStartDate);
    this.currentTabIndex = -1;
    // release holds before setting to new holds/slots
    if (this.isBackToBackRequired && this.selectedAppointments.length > 1) {

      this.selectedAppointments.forEach((appt) => {
        if (appt.hold && appt.hold.id) {
          this.schedulingApiService.releaseHold(appt.hold).subscribe((res) => {
            this.prevSelectedHoldObjArr = this.prevSelectedHoldObjArr.filter((slotObj: Hold) => {
              return this.holdSlotObj.slot.id != slotObj.slot.id
            });
            this.holdSlotObj.id = null;
            this.selectedExamDetailService.setprevSelectedHoldObj(this.prevSelectedHoldObjArr);
          })
        }
      })
    }

    if (this.holdSlotObj && this.holdSlotObj.id && this.selectedAppointments.length == 1) {
      // release hold when a slot is selected again
      this.schedulingApiService.releaseHold(this.holdSlotObj).subscribe((res) => {
        this.prevSelectedHoldObjArr = this.prevSelectedHoldObjArr.filter((slotObj: Hold) => {
          return this.holdSlotObj.slot.id != slotObj.slot.id
        });
        this.holdSlotObj.id = null;
        this.timerService.clearClock();
        this.selectedExamDetailService.setprevSelectedHoldObj(this.prevSelectedHoldObjArr);
      });
    }

    this.selectedAppointments[this.selectedIndex].appointmentSlot = new AppointmentSlot();
    this.selectedAppointments[this.selectedIndex].hold = new Hold();

    // remove previous selections in case of b2b
    if (this.isBackToBackRequired) {
      this.selectedAppointments.forEach((appt) => {
        appt.appointmentSlot = new AppointmentSlot();
        appt.hold = new Hold();
      });
      this.timerService.clearClock();
    }

    const year = selectedStartDate.split("-")[0];
    const month = selectedStartDate.split("-")[1];
    const day = selectedStartDate.split("-")[2];

    let formatStartDate: any = moment(new Date(year, month - 1, day)).format('MM-DD-YYYY');
    this.getSlots(siteSlot.id, formatStartDate, formatStartDate).subscribe((slots: any) => {
      siteSlot.slots = slots;
      this.selectedSiteSlot.slots = this.setApplicableSlots(siteSlot).slots;

      this.noAvailability = !this.selectedSiteSlot.slots.length;

      this.selectedExamDetailService.setSelectedAvailableSlots(this.selectedSiteSlot.slots);

      this.slotsCheck.emit(false);

    });
    this.lat = siteSlot.location.coordinates[0]; //focus in the site pin on map
    this.lng = siteSlot.location.coordinates[1];
    this.zoom = this.zoomOnFocus;
  }

  /* validate the time range based on exam duration and show the available slots */
  private setApplicableSlots(applicableSiteSlot: SiteSlot): SiteSlot {
    let bookedSlots: any[] = [];
    let hasAllExamSelectedForSchedule: boolean = false;
    let tempSelectedAppointments: AppointmentDetail[] = [];

    if (this.targetFlow == TargetFlow.Schedule) {
      tempSelectedAppointments = this.selectedAppointments;
    }
    else if (this.targetFlow == TargetFlow.Reschedule) {
      // Remove the cancelled appointments
      tempSelectedAppointments = this.allAppointmentDetailData.filter(item => item.status != "Cancelled");
      hasAllExamSelectedForSchedule = (tempSelectedAppointments.length == this.selectedAppointments.length) ? true : false;

      /* Filter out only those appointments which are not selected for re-schedule. All the selected appointments will go at once for FINRA and we have to remove
      time slots of appointment which are not selected for re-schedule.*/
      this.selectedAppointments.forEach((selectedAppointment, index) => {
        tempSelectedAppointments = tempSelectedAppointments.filter(item => item.ConfirmationNumber != selectedAppointment.ConfirmationNumber);
      });
    }

    // If all exams are selected for re-schedule in that case no need to filter slots, selected slot will handle all exams at once (B2B required)
    if ((!this.isBackToBackRequired && this.targetFlow == TargetFlow.Schedule) || (this.targetFlow == TargetFlow.Reschedule && !hasAllExamSelectedForSchedule)) {

      tempSelectedAppointments.forEach((appointment) => {
        if ((this.targetFlow == TargetFlow.Schedule && appointment.hold != null && appointment.hold != undefined && appointment.hold.id != undefined) ||
          (this.targetFlow == TargetFlow.Reschedule)) {
          bookedSlots.push({
            TestStartDate: moment(appointment.appointmentSlot.startDateTime).format("MM-DD-YYYY hh:mm A"),
            TestEndDate: moment(appointment.appointmentSlot.startDateTime).add(appointment.exam.duration, 'minutes').format("MM-DD-YYYY hh:mm A")
          });
        }
      });
      let applicableSlots: Slot[] = applicableSiteSlot.slots;
      applicableSiteSlot.slots.forEach((applicableSlot) => {
        if (this.isSlotAlreadyBooked(bookedSlots, applicableSlot)) {
          applicableSlots = applicableSlots.filter(item => item.id != applicableSlot.id);
        }
      });
      applicableSiteSlot.slots = applicableSlots;
    }
    if (this.targetFlow === TargetFlow.Reschedule) {
      applicableSiteSlot.slots = this.filterSameApptSlots(applicableSiteSlot, this.scheduledSlot);
    }

    return applicableSiteSlot;
  }

  /* Check Slot is already booked for that time or not */
  private isSlotAlreadyBooked(bookedSlots: any[], findSlot: Slot): boolean {
    let returnStatus: boolean = false;

    bookedSlots.forEach((bookedDate) => {
      let currentSlotDate: any = moment(findSlot.startDateTime).format("MM-DD-YYYY hh:mm A");

      if (moment(currentSlotDate).isSame(bookedDate.TestStartDate) ||
        moment(currentSlotDate).isBetween(bookedDate.TestStartDate, bookedDate.TestEndDate)) {
        returnStatus = true;
      }
      let currentExamDuration: number = this.selectedAppointments[this.selectedIndex].exam.duration;
      let currentExamEndDate: any = moment(currentSlotDate).add(currentExamDuration, 'minutes').format("MM-DD-YYYY hh:mm A");

      if (this.isDateRangeOverlaps(new Date(bookedDate.TestStartDate), new Date(bookedDate.TestEndDate), new Date(currentSlotDate), new Date(currentExamEndDate))) {
        returnStatus = true;
      }
    });

    return returnStatus;
  }

  /* Refresh the siteslot page if user changes region from pop up */
  private isDateRangeOverlaps(firstStartDate: Date, firstEndDate: Date, secondStartDate: Date, secondEndDate: Date): boolean {
    let latestDate: any = new Date(Math.max.apply(null, [firstStartDate, secondStartDate]));
    var earliestdate: any = new Date(Math.min.apply(null, [firstEndDate, secondEndDate]));
    if (latestDate < earliestdate) {
      return true;
    }
  }

  /* Refresh the siteslot page if user changes region from pop up */
  public refreshSiteSlotsByRegion(event: any): void {
    this.region$ = this.selectedExamDetailService.region.subscribe(region => {
      this.region = region;
    });
    this.popLocationSelector.actionTxt = this.region.name;
    this.lat = this.region.lat;
    this.lng = this.region.long;
    this.zoom = this.zoomDefault;
    var selectedStartDate = this.utilityService.getFormatToMMDDYYYY(new Date(this.selectedStartDate['jsdate']), "-");
    var selectedEndDate = this.utilityService.getFormatToMMDDYYYY(new Date(this.selectedEndDate['jsdate']), "-");
    this.skipSiteSlotsize = 0;
    this.selectedExamDetailService.setSkipSize(this.skipSiteSlotsize);
    this.getSites(
      selectedStartDate,
      selectedEndDate,
      this.region.lat,
      this.region.long
    ).subscribe((siteSlots: any) => {
      this.selectedSiteSlotIdentifier = "";
      siteSlots.forEach((slots: any) => {
        slots.availability = slots.availability.slice(0, this.testCenterCalendarDays);
        slots.availability.forEach((availDate: string) => {
          var slotIdentifier = this.generateSiteSlotIdentifier(slots, availDate);
          this.testCenterDateLabel.set(slotIdentifier, this.utilityService.convertDateToWords(availDate, ','));
          this.testCenterMonth.set(slotIdentifier, this.datePipe.transform(availDate, 'MMM').toUpperCase());
          this.testCenterDate.set(slotIdentifier, this.datePipe.transform(availDate, 'dd'));
        });
      });
      this.siteSlots = siteSlots;
      this.loadMapWithMarkers(this.siteSlots);
      this.prevSites = this.checkIfExists(this.prevSites, this.siteSlots);
      this.selectedExamDetailService.setPrevSites(this.prevSites);
      this.resetCurrentSelection();
    });
    this.IsCurrentFormChanged = true;
    //sets location for /scheduling/scheduleTestcenter
    this.selectedAppointments[this.selectedIndex].region = this.region;
    //sets location for /scheduling/scheduleLocation
    this.locationSelector.region = this.region;
  }

  /* Apply sorting based on user input */
  public ApplySorting(propertyName: string, devicetype: string) {
    if (propertyName == "Distance") {
      return function (a: any, b: any) {
        return a.location.distance - b.location.distance;
      }
    }
    else {
      return function (a: any, b: any) {
        return new Date(a.Testdate).getTime() -
          new Date(b.Testdate).getTime()
      }
    }
  }

  /* Set metric details in shared service */
  private setMetricsDetail(
    metricType: MetricType,
    siteId?: string,
    slotdate?: any,
    examId?: string
  ): void {
    const firstDateAvailable = this.selectedSite ? moment(this.selectedSite.availability[0]).format("YYYY-MM-DDTHH:mm:ss") : this.selectedStartDate.date;
    if (this.metricsDetail == null || this.metricsDetail == undefined) {
      this.metricsDetail = [];
      let metricDetails = new MetricDetails();
      this.metricsDetail.push(metricDetails);
    }
    else if (this.metricsDetail != null && this.selectedIndex > this.metricsDetail.length) {

      let metricDetails = new MetricDetails();
      this.metricsDetail.push(metricDetails);
    }
    if (metricType === MetricType.BestSite && this.region) {

      this.metricsDetail[this.selectedIndex].bestSite = new MetricData(
        MetricType.BestSite,
        { "latitude": this.region.lat, "longitude": this.region.long, "siteId": siteId },
        slotdate
      );
      this.selectedExamDetailService.setMetricsDetail(this.metricsDetail);
    }
    else if (metricType === MetricType.Selected && this.region) {
      this.metricsDetail[this.selectedIndex].selected = new MetricData(
        MetricType.Selected,
        { "latitude": this.region.lat, "longitude": this.region.long, "siteId": siteId },
        slotdate
      );
      this.metricsDetail[this.selectedIndex].examId = examId;
      this.selectedExamDetailService.setMetricsDetail(this.metricsDetail);
    }
    else if (metricType === MetricType.BestDate) {
      this.metricsDetail[this.selectedIndex].bestDate = new MetricData(
        MetricType.BestDate,
        {
          "searchedSiteId": this.metricsDetail[this.selectedIndex].selected.data.siteId,
          "offeredSiteId": this.metricsDetail[this.selectedIndex].bestSite.data.siteId,
          "searchedDate": this.utilityService.getFormatToMMDDYYYY(new Date(this.selectedStartDate.date), "-")
        },
        this.utilityService.getFormatToMMDDYYYY(new Date(firstDateAvailable), "-")
      );

      this.selectedExamDetailService.setMetricsDetail(this.metricsDetail);
    }
    else if (metricType === MetricType.Searched && this.region) {
      this.metricsDetail[this.selectedIndex].searched = new MetricData(
        MetricType.Searched,
        { "latitude": this.region.lat, "longitude": this.region.long },
        this.selectedExamDetailService.setMetricsDetail(this.metricsDetail)
      );
      if (!this.firstTimeLocationSearch[this.selectedIndex]) {
        this.firstTimeLocationSearch[this.selectedIndex] = true;
        this.selectedExamDetailService.setFirstTimeLocationSearch(this.firstTimeLocationSearch);
      } else {
        this.firstTimeLocationSearch[this.selectedIndex] = false;
        this.selectedExamDetailService.setFirstTimeLocationSearch(this.firstTimeLocationSearch);
      }
    }
  }

  /**
   * checks if the sites to insert were already part of the array to store,
   * and just replace using the index of the sites array
   * @param arr
   * @param siteSlots
   */
  public checkIfExists(arr: Array<any>, siteSlots: SiteSlot[]) {
    const arrayToCheck = arr.slice();

    if (arrayToCheck && arrayToCheck.length) {
      if (this.prevSelectionsArr.length >= (this.selectedIndex + 1)) {
        arrayToCheck[this.selectedIndex] = siteSlots;
      } else {
        arrayToCheck.push(siteSlots);
      }
    } else {
      arrayToCheck.push(siteSlots);
    }
    return arrayToCheck;
  }

  /**
   * filter the same scheduled slot when trying to schedule
   * using a unique id created using siteid and timestamp
   * @param siteSlot
   * @param scheduledSlot
   */
  public filterSameApptSlots(siteSlot: SiteSlot, scheduledSlot: AppointmentSlot) {
    const splitSite = scheduledSlot.site && scheduledSlot.site.href ? scheduledSlot.site.href.split('/') : [];
    const siteId = splitSite[splitSite.length - 2] // siteid is last attribute // TBD - MM
    const startDateTime = moment(scheduledSlot.startDateTime).format("YYYY-MM-DDTHH:mm:ss");
    const scheduledUri = siteId + startDateTime;

    let slots = siteSlot.slots.filter((slot) => {
      const uri = siteSlot.id + slot.startDateTime;
      return uri !== scheduledUri;
    })
    return slots;
  }

  getFocus(event: any): void {
    if (event) {
      setTimeout(function () {
        event.popover.elementRef.nativeElement.nextElementSibling.focus();
      }, 100);
    }
  }

  milesToKm(miles: number): number {
    return this.cultureService.convertMilesToKm(miles);
  }

  setUnit(unit: DistanceUnits) {
    this.selectedExamDetailService.setDistanceUnit(unit);
  }
}
